import styled from "@emotion/styled";

export const Container = styled.div<{ size: string }>`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  padding: ${(p) => (p.size === "small" ? "0" : "2rem")};
  border-radius: 1rem;
  color: ${(p) => p.theme.text.colors.primary};
  background-color: ${(p) => p.theme.colors.background};
  width: 100%;

  &[aria-disabled="true"] {
    opacity: 0.5;
    pointer-events: none;
  }

  span {
    color: ${(p) => p.theme.text.colors.primary}!important;
  }
`;
export const FormItem = styled.div<{ size: string }>`
  display: grid;
  grid-template-columns: 1fr auto;
  justify-content: space-evenly;
  align-items: center;
  position: relative;
  width: 100%;
  min-height: 50px;
  min-height: ${(p) => (p.size === "small" ? "0" : "50px")};

  p {
    font-size: ${(p) =>
      p.size === "small" ? p.theme.text.fontSizes.m : p.theme.text.fontSizes.l};
  }

  &:not(:first-of-type) {
    &:after {
      content: "";
      height: 1px;
      width: 100%;
      background-color: ${(p) => p.theme.colors.border};
      position: absolute;
      top: -1.25rem;
      left: 0;
    }
  }
`;
